export const exactStringMatchFilter = (option, searchText) =>
  option.data.label.toLowerCase().startsWith(searchText.toLowerCase()) ||
  option.data.value.toLowerCase().startsWith(searchText.toLowerCase());
